import { IconButton, Tooltip, TextField, Autocomplete } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import { grey } from "@mui/material/colors";

import { Calendar } from "../../../common/components/calendar";
import { Misa_card } from "./Misa_card";

export const DiaCard = (props) => {
  const { dia, setRol } = props;

  //State actual

  const [stateLocal, setStateLocal] = useState({ ...dia });

  const [nuevaCeremonia, setNuevaCeremonia] = useState({
    id_ceremonia: 1,
    tipo_misa: "",
    horario: "",
    acolitos: [{ id: 0, id_acolito: 0, id_puesto: 0, nombre: "", puesto: "" }],
  });

  useEffect(() => {
    setRol((rol) => {
      const newRol = rol.map((d) => {
        if (d.id_dia === dia.id_dia) {
          return stateLocal;
        } else {
          return d;
        }
      });

      return newRol;
    });
  }, [stateLocal]);

  const handleEditDia = (value) => {
    setStateLocal({
      ...stateLocal,
      ...value,
    });
  };

  const handleAddCeremonia = () => {
    const id_nuevaCeremonia = nuevaCeremonia.id_ceremonia + 1;

    setNuevaCeremonia({
      ...nuevaCeremonia,
      id_ceremonia: id_nuevaCeremonia,
    });

    setStateLocal({
      ...stateLocal,
      ceremonias: [
        ...stateLocal.ceremonias,
        { ...nuevaCeremonia, id_ceremonia: id_nuevaCeremonia },
      ],
    });
  };

  const handleEditCeremonia = (ceremonia) => {
    const newCeremonias = stateLocal.ceremonias.map((c) => {
      if (c.id_ceremonia === ceremonia.id_ceremonia) {
        return ceremonia;
      } else {
        return c;
      }
    });

    setStateLocal({
      ...stateLocal,
      ceremonias: newCeremonias,
    });
  };

  const handleDeleteCeremonia = (id_ceremonia) => {
    const newCeremonias = stateLocal.ceremonias.filter(
      (c) => c.id_ceremonia !== id_ceremonia
    );
    setStateLocal({
      ...stateLocal,
      ceremonias: newCeremonias,
    });
  };

  return (
    <div
      style={{
        marginTop: 40,
        display: "flex",
        flex: 1,
        border: "solid",
        borderRadius: 10,
        borderColor: grey[500],
        marginBottom: 20,
      }}
    >
      <div
        style={{
          flex: 1,
          padding: 20,
          borderRightStyle: "solid",
          // borderWidth: 2,
          borderRightColor: grey[500],
          justifyContent: "center",
          // alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Calendar setFecha={handleEditDia} label={"DÍA DE LA CEREMONIA"} />
        <TextField
          id="standard-basic"
          label="Festividad"
          variant="standard"
          fullWidth
          style={{
            marginTop: 20,
            marginBottom: 50,
          }}
          value={stateLocal.festividad}
          onChange={(value) => {
            handleEditDia({ festividad: value.target.value });
          }}
        />
        <div
          style={{
            display: "flex",
            // backgroundColor: "red",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Autocomplete
            disablePortal
            // freeSolo
            options={[1, 2, 3, 4]}
            sx={{ width: 100 }}
            renderInput={(params) => <TextField {...params} label="Clase" />}
            getOptionLabel={(option) => option.toString()}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={(event, value) => {
              value
                ? handleEditDia({ clase: value })
                : handleEditDia({ clase: 0 });
            }}
            noOptionsText="Sin resultados"
          />
          <Autocomplete
            disablePortal
            freeSolo
            options={[
              "Blanco",
              "Verde",
              "Rojo",
              "Morado",
              "Rosa",
              "Dorado",
              "Azul",
              "Negro",
            ]}
            sx={{ width: 200 }}
            renderInput={(params) => (
              <TextField {...params} label="Color de Ornamentos" />
            )}
            getOptionLabel={(option) => option}
            isOptionEqualToValue={(option, value) => option === value}
            onInputChange={(event, value) => {
              value
                ? handleEditDia({ color_ornamentos: value })
                : handleEditDia({ color_ornamentos: "" });
            }}
            value={stateLocal.color_ornamentos}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flex: 3,
          textAlign: "center",
          flexDirection: "column",
        }}
      >
        {stateLocal.ceremonias.map((ceremonia) => (
          // eslint-disable-next-line react/jsx-pascal-case
          <Misa_card
            key={ceremonia.id_ceremonia}
            ceremonia={ceremonia}
            onEdit={handleEditCeremonia}
            onDelete={handleDeleteCeremonia}
          />
        ))}

        <div
          style={{
            marginTop: 10,
            marginRight: 40,
            display: "flex",
            flex: 1,
          }}
        >
          <IconButton
            sx={{ color: grey[300], marginLeft: 15, marginBottom: 1 }}
            onClick={handleAddCeremonia}
          >
            <Tooltip title="Agregar otra Ceremonia" placement="right">
              <AddCircleRoundedIcon sx={{ fontSize: 55 }} />
            </Tooltip>
          </IconButton>
        </div>
      </div>
    </div>
  );
};
